import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from './en';

export const translationProvider = polyglotI18nProvider(locale => englishMessages,'en');
